import FilterSidebar from '@components/FilterSidebar/FilterSidebar';
import React, { FunctionComponent, useEffect } from 'react';

import { getList, reset } from '@stores/registrationIps';
import RegistrationIpsFilters from '@components/RegistrationIpsFilters';
import RegistrationIpsTable from '@components/RegistrationIpsTable';

import css from './RegistrationIpsRoute.module.less';

interface RegistrationIpsRouteProps {}

const RegistrationIpsRoute: FunctionComponent<RegistrationIpsRouteProps> = () => {
  useEffect(() => {
    getList();

    return () => {
      reset();
    };
  }, []);

  return (
    <div className={css.root}>
      <FilterSidebar className={css.sidebar}>
        <RegistrationIpsFilters />
      </FilterSidebar>

      <div className={css.content}>
        <RegistrationIpsTable />
      </div>
    </div>
  );
};

export default RegistrationIpsRoute;
